"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7754],{

/***/ 42820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _store_slices_category__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10328);
/* harmony import */ var _utils_text_methods__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82560);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);






var CatgeoryBreadcrumb = function() {
    var ref;
    var categoryState = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_store_slices_category__WEBPACK_IMPORTED_MODULE_1__/* .selectCategory */ .uY);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        "aria-label": "breadcrumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
            className: "breadcrumb",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "breadcrumb-item",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/",
                        children: "Home"
                    })
                }),
                categoryState.mapping.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "breadcrumb-item",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/jewellery/category/".concat(item.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: (0,_utils_text_methods__WEBPACK_IMPORTED_MODULE_5__/* .toTitleCase */ .L)(item.name)
                            })
                        })
                    }, item.slug);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "breadcrumb-item active ms-2",
                    children: (0,_utils_text_methods__WEBPACK_IMPORTED_MODULE_5__/* .toTitleCase */ .L)(((ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.name) || "")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CatgeoryBreadcrumb);


/***/ }),

/***/ 15745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ filters; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/assets/images/fast.svg
var fast = __webpack_require__(37726);
// EXTERNAL MODULE: ./src/store/slices/category.ts
var category = __webpack_require__(10328);
// EXTERNAL MODULE: ./src/styles/product_list.module.scss
var product_list_module = __webpack_require__(79356);
var product_list_module_default = /*#__PURE__*/__webpack_require__.n(product_list_module);
// EXTERNAL MODULE: ./src/utils/combineCategoryFilters.ts
var combineCategoryFilters = __webpack_require__(48825);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/category-unbxd/pagination-counter/pagination-counter.tsx
var pagination_counter = __webpack_require__(43977);
// EXTERNAL MODULE: ./src/components/common/single-dropdown/single-dropdown.tsx
var single_dropdown = __webpack_require__(60805);
;// CONCATENATED MODULE: ./src/components/category-unbxd/filters/sort-filter/sort-filter.tsx









var SortFilter = function(param) {
    var isSearch = param.isSearch;
    var router = (0,next_router.useRouter)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var sortFilters = [
        {
            label: "Relevance",
            value: ""
        },
        {
            label: "Price: Low to High",
            value: "price-asc"
        },
        {
            label: "Price: High to Low",
            value: "price-desc"
        }, 
    ];
    var sortFilterChange = function(value) {
        var ref;
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    sort: value
                }))), {
                    q: router.query.q,
                    try_it_online: router.query.try_it_online
                })
            }, undefined, {
                shallow: true
            });
            return;
        }
        router.replace({
            pathname: "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                sort: value
            })))
        }, undefined, {
            shallow: true
        });
    };
    var label = (0,react.useMemo)(function() {
        var ref;
        return ((ref = sortFilters.find(function(v) {
            return v.value == (router.query.sort || "");
        })) === null || ref === void 0 ? void 0 : ref.label) || "Relevance";
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router.query.sort
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_dropdown/* default */.Z, {
        label: label,
        items: sortFilters,
        onChange: sortFilterChange,
        showSelected: true
    });
};
/* harmony default export */ var sort_filter = (SortFilter);

// EXTERNAL MODULE: ./src/hooks/useOnClickOutside.ts
var useOnClickOutside = __webpack_require__(98850);
;// CONCATENATED MODULE: ./src/components/category-unbxd/filters/desktop-filter-dropdown/desktop-filter-dropdown.tsx














var priceFilters = [
    {
        label: "Below ₹ 10,000",
        value: {
            max: 10000
        }
    },
    {
        label: "₹ 10,000 - ₹ 20,000",
        value: {
            min: 10000,
            max: 20000
        }
    },
    {
        label: "₹ 20,000 - ₹ 30,000",
        value: {
            min: 20000,
            max: 30000
        }
    },
    {
        label: "₹ 30,000 - ₹ 40,000",
        value: {
            min: 30000,
            max: 40000
        }
    },
    {
        label: "₹ 40,000 - ₹ 50,000",
        value: {
            min: 40000,
            max: 50000
        }
    },
    {
        label: "₹ 50,000 and Above",
        value: {
            min: 50000
        }
    }, 
];
var CheckIcon = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20 6L9 17L4 12",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var DesktopFilterDropdown = function(param) {
    var isSearch = param.isSearch;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var router = (0,next_router.useRouter)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var ref12 = (0,react.useState)(false), open = ref12[0], setOpen = ref12[1];
    var ref13 = (0,react.useRef)(null);
    (0,useOnClickOutside/* default */.Z)(ref13, function() {
        return setOpen(false);
    });
    var ref14 = (0,react.useState)([
        "categories",
        "price",
        "metal",
        "occasion", 
    ]), openAccordions = ref14[0], setOpenAccordions = ref14[1];
    var toggleAccordion = function(name) {
        if (openAccordions.includes(name)) {
            setOpenAccordions(openAccordions.filter(function(a) {
                return a !== name;
            }));
        } else {
            setOpenAccordions((0,_to_consumable_array/* default */.Z)(openAccordions).concat([
                name
            ]));
        }
    };
    // Data processing
    var categoryFacet = categoryState === null || categoryState === void 0 ? void 0 : (ref = categoryState.facets) === null || ref === void 0 ? void 0 : (ref1 = ref.multilevel) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.list) === null || ref2 === void 0 ? void 0 : ref2.find(function(x) {
        return x.filterField == "categoryPath";
    });
    var categoryDisplayName = (categoryFacet === null || categoryFacet === void 0 ? void 0 : categoryFacet.displayName) || "Categories";
    var categoryValues = (categoryFacet === null || categoryFacet === void 0 ? void 0 : categoryFacet.values) || [];
    var categoryItems = categoryValues.map(function(v) {
        return {
            label: "".concat(v.name, " (").concat(v.count, ")"),
            value: v.name
        };
    });
    var metalArray = (ref6 = categoryState === null || categoryState === void 0 ? void 0 : (ref3 = categoryState.facets) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.text) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.list) === null || ref5 === void 0 ? void 0 : ref5.find(function(x) {
        return x.facetName == "vPurity_uFilter";
    })) === null || ref6 === void 0 ? void 0 : ref6.values;
    var metalItems = (metalArray === null || metalArray === void 0 ? void 0 : metalArray.reduce(function(acc, cur, index) {
        if (index % 2 === 0) {
            acc.push({
                label: "".concat(cur, " (").concat(metalArray[index + 1], ")"),
                value: cur
            });
        }
        return acc;
    }, [])) || [];
    var occasionArray = (ref10 = categoryState === null || categoryState === void 0 ? void 0 : (ref7 = categoryState.facets) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.text) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.list) === null || ref9 === void 0 ? void 0 : ref9.find(function(x) {
        return x.facetName == "vOccasions_uFilter";
    })) === null || ref10 === void 0 ? void 0 : ref10.values;
    var occasionItems = (occasionArray === null || occasionArray === void 0 ? void 0 : occasionArray.reduce(function(acc, cur, index) {
        if (index % 2 === 0) {
            acc.push({
                label: "".concat(cur, " (").concat(occasionArray[index + 1], ")"),
                value: cur
            });
        }
        return acc;
    }, [])) || [];
    // Active filters mapping
    var activeCategory = !isSearch ? categoryState === null || categoryState === void 0 ? void 0 : (ref11 = categoryState.data) === null || ref11 === void 0 ? void 0 : ref11.name : null;
    var activePriceLabel = null;
    var qPriceMin = router.query.priceMin ? Number(router.query.priceMin) : undefined;
    var qPriceMax = router.query.priceMax ? Number(router.query.priceMax) : undefined;
    var activePriceObj = priceFilters.find(function(p) {
        return p.value.min === qPriceMin && p.value.max === qPriceMax;
    });
    if (activePriceObj) {
        activePriceLabel = activePriceObj.label;
    }
    var activeMetals = [];
    if (router.query.metal) {
        activeMetals = typeof router.query.metal === "string" ? [
            router.query.metal
        ] : router.query.metal;
    }
    var activeOccasions = [];
    if (router.query.occasion) {
        activeOccasions = typeof router.query.occasion === "string" ? [
            router.query.occasion
        ] : router.query.occasion;
    }
    // Action handlers
    var handleCategoryChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(catName) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (catName) {
                            _ctx.next = 3;
                            break;
                        }
                        router.push({
                            pathname: "/jewellery"
                        });
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return http_client/* default.get */.Z.get(endpoints/* default.products.categorySlugbyName */.Z.products.categorySlugbyName(catName));
                    case 6:
                        data = _ctx.sent.data;
                        if (data) {
                            router.push({
                                pathname: "/jewellery/category/".concat(data.slug)
                            });
                        }
                        _ctx.next = 12;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10
                ]
            ]);
        }));
        return function handleCategoryChange(catName) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearCategory = function() {
        router.push({
            pathname: "/jewellery"
        });
    };
    var handlePriceChange = function(value) {
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    priceMin: value.min,
                    priceMax: value.max
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
        } else {
            var ref;
            router.replace({
                pathname: "/jewellery/category/[category]",
                query: (0,_object_spread/* default */.Z)({
                    category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    priceMin: value.min,
                    priceMax: value.max
                })))
            }, undefined, {
                shallow: true
            });
        }
    };
    var clearPrice = function() {
        handlePriceChange({
            min: undefined,
            max: undefined
        });
    };
    var handleMetalChange = function(metalVal) {
        var newMetals = (0,_to_consumable_array/* default */.Z)(activeMetals);
        if (newMetals.includes(metalVal)) {
            newMetals = newMetals.filter(function(m) {
                return m !== metalVal;
            });
        } else {
            newMetals.push(metalVal);
        }
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    metal: newMetals
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
        } else {
            var ref;
            router.replace({
                pathname: "/jewellery/category/[category]",
                query: (0,_object_spread/* default */.Z)({
                    category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    metal: newMetals
                })))
            }, undefined, {
                shallow: true
            });
        }
    };
    var clearMetal = function(metalVal) {
        handleMetalChange(metalVal);
    };
    var handleOccasionChange = function(occasionVal) {
        var newOccasions = (0,_to_consumable_array/* default */.Z)(activeOccasions);
        if (newOccasions.includes(occasionVal)) {
            newOccasions = newOccasions.filter(function(o) {
                return o !== occasionVal;
            });
        } else {
            newOccasions.push(occasionVal);
        }
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    occasion: newOccasions
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
        } else {
            var ref;
            router.replace({
                pathname: "/jewellery/category/[category]",
                query: (0,_object_spread/* default */.Z)({
                    category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    occasion: newOccasions
                })))
            }, undefined, {
                shallow: true
            });
        }
    };
    var clearOccasion = function(occasionVal) {
        handleOccasionChange(occasionVal);
    };
    var clearAll = function() {
        router.push({
            pathname: "/jewellery"
        });
    };
    var hasAnyFilter = activeCategory || activePriceLabel || activeMetals.length > 0 || activeOccasions.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "d-flex align-items-center flex-wrap gap-3",
        style: {
            position: "relative"
        },
        ref: ref13,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            return setOpen(!open);
                        },
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            background: "#fff",
                            border: "1px solid #ddd",
                            padding: "8px 16px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "500"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M22 3H2L10 12.46V19L14 21V12.46L22 3Z",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            "Filter By",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                style: {
                                    transform: open ? "rotate(180deg)" : "none",
                                    transition: "0.2s"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M6 9L12 15L18 9",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }),
                    open && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "absolute",
                            top: "calc(100% + 8px)",
                            left: 0,
                            width: "300px",
                            background: "#fff",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            borderRadius: "8px",
                            zIndex: 100,
                            maxHeight: "450px",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    padding: "16px",
                                    overflowY: "auto",
                                    flex: 1
                                },
                                children: [
                                    categoryItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            marginBottom: "16px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: function() {
                                                    return toggleAccordion("categories");
                                                },
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    cursor: "pointer",
                                                    fontWeight: "600",
                                                    marginBottom: openAccordions.includes("categories") ? "12px" : "0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            categoryDisplayName,
                                                            " (",
                                                            activeCategory ? 1 : 0,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: openAccordions.includes("categories") ? "▲" : "▼"
                                                    })
                                                ]
                                            }),
                                            openAccordions.includes("categories") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "10px"
                                                },
                                                children: categoryItems.map(function(cat) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            cursor: "pointer",
                                                            margin: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: activeCategory === cat.value,
                                                                onChange: function() {
                                                                    return handleCategoryChange(cat.value);
                                                                },
                                                                style: {
                                                                    accentColor: "#a31d24",
                                                                    width: "16px",
                                                                    height: "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: activeCategory === cat.value ? "#a31d24" : "inherit",
                                                                    fontWeight: activeCategory === cat.value ? "500" : "400"
                                                                },
                                                                children: cat.label
                                                            })
                                                        ]
                                                    }, cat.value);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            marginBottom: "16px",
                                            borderTop: "1px solid #f0f0f0",
                                            paddingTop: "16px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: function() {
                                                    return toggleAccordion("price");
                                                },
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    cursor: "pointer",
                                                    fontWeight: "600",
                                                    marginBottom: openAccordions.includes("price") ? "12px" : "0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Price (",
                                                            activePriceLabel ? 1 : 0,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: openAccordions.includes("price") ? "▲" : "▼"
                                                    })
                                                ]
                                            }),
                                            openAccordions.includes("price") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "10px"
                                                },
                                                children: priceFilters.map(function(p) {
                                                    var isChecked = activePriceLabel === p.label;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            cursor: "pointer",
                                                            margin: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: isChecked,
                                                                onChange: function() {
                                                                    if (isChecked) clearPrice();
                                                                    else handlePriceChange(p.value);
                                                                },
                                                                style: {
                                                                    accentColor: "#a31d24",
                                                                    width: "16px",
                                                                    height: "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: isChecked ? "#a31d24" : "inherit",
                                                                    fontWeight: isChecked ? "500" : "400"
                                                                },
                                                                children: p.label
                                                            })
                                                        ]
                                                    }, p.label);
                                                })
                                            })
                                        ]
                                    }),
                                    metalItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            marginBottom: "16px",
                                            borderTop: "1px solid #f0f0f0",
                                            paddingTop: "16px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: function() {
                                                    return toggleAccordion("metal");
                                                },
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    cursor: "pointer",
                                                    fontWeight: "600",
                                                    marginBottom: openAccordions.includes("metal") ? "12px" : "0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Metal (",
                                                            activeMetals.length,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: openAccordions.includes("metal") ? "▲" : "▼"
                                                    })
                                                ]
                                            }),
                                            openAccordions.includes("metal") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "10px"
                                                },
                                                children: metalItems.map(function(m) {
                                                    var isChecked = activeMetals.includes(m.value);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            cursor: "pointer",
                                                            margin: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: isChecked,
                                                                onChange: function() {
                                                                    return handleMetalChange(m.value);
                                                                },
                                                                style: {
                                                                    accentColor: "#a31d24",
                                                                    width: "16px",
                                                                    height: "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: isChecked ? "#a31d24" : "inherit",
                                                                    fontWeight: isChecked ? "500" : "400"
                                                                },
                                                                children: m.label
                                                            })
                                                        ]
                                                    }, m.value);
                                                })
                                            })
                                        ]
                                    }),
                                    occasionItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            marginBottom: "16px",
                                            borderTop: "1px solid #f0f0f0",
                                            paddingTop: "16px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: function() {
                                                    return toggleAccordion("occasion");
                                                },
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    cursor: "pointer",
                                                    fontWeight: "600",
                                                    marginBottom: openAccordions.includes("occasion") ? "12px" : "0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Occasion (",
                                                            activeOccasions.length,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: openAccordions.includes("occasion") ? "▲" : "▼"
                                                    })
                                                ]
                                            }),
                                            openAccordions.includes("occasion") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "10px"
                                                },
                                                children: occasionItems.map(function(m) {
                                                    var isChecked = activeOccasions.includes(m.value);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            cursor: "pointer",
                                                            margin: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: isChecked,
                                                                onChange: function() {
                                                                    return handleOccasionChange(m.value);
                                                                },
                                                                style: {
                                                                    accentColor: "#a31d24",
                                                                    width: "16px",
                                                                    height: "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: isChecked ? "#a31d24" : "inherit",
                                                                    fontWeight: isChecked ? "500" : "400"
                                                                },
                                                                children: m.label
                                                            })
                                                        ]
                                                    }, m.value);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    borderTop: "1px solid #f0f0f0",
                                    padding: "16px",
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: clearAll,
                                    style: {
                                        color: "#a31d24",
                                        background: "transparent",
                                        border: "1px solid #a31d24",
                                        borderRadius: "4px",
                                        padding: "8px 24px",
                                        width: "100%",
                                        fontWeight: "600"
                                    },
                                    children: "Clear All"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "24px",
                            display: "inline-block",
                            width: "1px",
                            background: "#ddd",
                            margin: "0 8px"
                        }
                    }),
                    activeCategory && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        style: {
                            background: "#f5f5f5",
                            padding: "9px 12px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "14px"
                        },
                        children: [
                            activeCategory,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: clearCategory,
                                style: {
                                    cursor: "pointer",
                                    opacity: 0.6,
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                },
                                children: "✕"
                            })
                        ]
                    }),
                    activePriceLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        style: {
                            background: "#f5f5f5",
                            padding: "9px 12px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "14px"
                        },
                        children: [
                            activePriceLabel,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: clearPrice,
                                style: {
                                    cursor: "pointer",
                                    opacity: 0.6,
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                },
                                children: "✕"
                            })
                        ]
                    }),
                    activeMetals.map(function(metal) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            style: {
                                background: "#f5f5f5",
                                padding: "9px 12px",
                                borderRadius: "6px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "14px"
                            },
                            children: [
                                metal,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: function() {
                                        return clearMetal(metal);
                                    },
                                    style: {
                                        cursor: "pointer",
                                        opacity: 0.6,
                                        fontSize: "12px",
                                        fontWeight: "bold"
                                    },
                                    children: "✕"
                                })
                            ]
                        }, metal);
                    }),
                    activeOccasions.map(function(occ) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            style: {
                                background: "#f5f5f5",
                                padding: "9px 12px",
                                borderRadius: "6px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "14px"
                            },
                            children: [
                                occ,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: function() {
                                        return clearOccasion(occ);
                                    },
                                    style: {
                                        cursor: "pointer",
                                        opacity: 0.6,
                                        fontSize: "12px",
                                        fontWeight: "bold"
                                    },
                                    children: "✕"
                                })
                            ]
                        }, occ);
                    }),
                    hasAnyFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: clearAll,
                        style: {
                            color: "#a31d24",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500",
                            marginLeft: "8px"
                        },
                        children: "Clear All"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var desktop_filter_dropdown = (DesktopFilterDropdown);

;// CONCATENATED MODULE: ./src/components/category-unbxd/filters/filters.tsx





















var CatgeoryFiltersUnbxd = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    var ref16 = (0,react.useState)(false), showFilter = ref16[0], setShowFilter = ref16[1];
    var ref17 = (0,react.useState)(false), showSort = ref17[0], setShowSort = ref17[1];
    var ref18 = (0,react.useState)(false), isSearch = ref18[0], setIsSearch = ref18[1];
    var priceFilters = [
        {
            label: "Below ₹ 10,000",
            value: {
                max: 10000
            }
        },
        {
            label: "₹ 10,000 - ₹ 20,000",
            value: {
                min: 10000,
                max: 20000
            }
        },
        {
            label: "₹ 20,000 - ₹ 30,000",
            value: {
                min: 20000,
                max: 30000
            }
        },
        {
            label: "₹ 30,000 - ₹ 40,000",
            value: {
                min: 30000,
                max: 40000
            }
        },
        {
            label: "₹ 40,000 - ₹ 50,000",
            value: {
                min: 40000,
                max: 50000
            }
        },
        {
            label: "₹ 50,000 and Above",
            value: {
                min: 50000
            }
        }, 
    ];
    (0,react.useEffect)(function() {
        if (router.route == "/jewellery") {
            setIsSearch(true);
        }
    }, [
        router.route
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (router.route === "/jewellery" && ((ref = router.query) === null || ref === void 0 ? void 0 : ref.q)) {
            setShowFilter(false);
        }
    }, [
        router.route,
        (ref = router.query) === null || ref === void 0 ? void 0 : ref.q
    ]);
    (0,react.useEffect)(function() {
        if (!isSearch && categoryState.data) {
            dispatch((0,category/* fetchCategoryMappingById */.qg)(categoryState.data.id));
        }
    }, [
        categoryState.data,
        dispatch,
        isSearch
    ]);
    var activeCategory = !isSearch ? categoryState === null || categoryState === void 0 ? void 0 : (ref1 = categoryState.data) === null || ref1 === void 0 ? void 0 : ref1.name : null;
    var activePriceLabel = null;
    var qPriceMin = router.query.priceMin ? Number(router.query.priceMin) : undefined;
    var qPriceMax = router.query.priceMax ? Number(router.query.priceMax) : undefined;
    var activePriceObj = priceFilters.find(function(p) {
        return p.value.min === qPriceMin && p.value.max === qPriceMax;
    });
    if (activePriceObj) {
        activePriceLabel = activePriceObj.label;
    }
    var activeMetals = [];
    if (router.query.metal) {
        activeMetals = typeof router.query.metal === "string" ? [
            router.query.metal
        ] : router.query.metal;
    }
    var activeOccasions = [];
    if (router.query.occasion) {
        activeOccasions = typeof router.query.occasion === "string" ? [
            router.query.occasion
        ] : router.query.occasion;
    }
    var clearCategory = function() {
        router.push({
            pathname: "/jewellery"
        });
    };
    var clearPrice = function() {
        var ref;
        var _query = router.query, priceMin = _query.priceMin, priceMax = _query.priceMax, rest = (0,_object_without_properties/* default */.Z)(_query, [
            "priceMin",
            "priceMax"
        ]);
        router.replace({
            pathname: isSearch ? "/jewellery" : "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)(rest), isSearch ? {
                q: router.query.q
            } : {
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            })
        }, undefined, {
            shallow: true
        });
    };
    var clearMetal = function(metalVal) {
        var ref;
        var newMetals = activeMetals.filter(function(m) {
            return m !== metalVal;
        });
        router.replace({
            pathname: isSearch ? "/jewellery" : "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                metal: newMetals
            })), isSearch ? {
                q: router.query.q
            } : {
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            })
        }, undefined, {
            shallow: true
        });
    };
    var handleOccasionChange = function(occasionVal) {
        var newOccasions = (0,_to_consumable_array/* default */.Z)(activeOccasions);
        if (newOccasions.includes(occasionVal)) {
            newOccasions = newOccasions.filter(function(o) {
                return o !== occasionVal;
            });
        } else {
            newOccasions.push(occasionVal);
        }
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    occasion: newOccasions
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
        } else {
            var ref;
            router.replace({
                pathname: "/jewellery/category/[category]",
                query: (0,_object_spread/* default */.Z)({
                    category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    occasion: newOccasions
                })))
            }, undefined, {
                shallow: true
            });
        }
    };
    var clearOccasion = function(occasionVal) {
        handleOccasionChange(occasionVal);
    };
    var clearAll = function() {
        router.push({
            pathname: "/jewellery"
        });
    };
    var hasAnyFilter = activeCategory || activePriceLabel || activeMetals.length > 0 || activeOccasions.length > 0;
    var ref19 = (0,react.useState)([
        "categories",
        "price",
        "metal",
        "occasion", 
    ]), openAccordions = ref19[0], setOpenAccordions = ref19[1];
    var toggleAccordion = function(name) {
        if (openAccordions.includes(name)) {
            setOpenAccordions(openAccordions.filter(function(a) {
                return a !== name;
            }));
        } else {
            setOpenAccordions((0,_to_consumable_array/* default */.Z)(openAccordions).concat([
                name
            ]));
        }
    };
    // Data processing for mobile drawer
    var categoryFacet = categoryState === null || categoryState === void 0 ? void 0 : (ref2 = categoryState.facets) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.multilevel) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.list) === null || ref4 === void 0 ? void 0 : ref4.find(function(x) {
        return x.filterField == "categoryPath";
    });
    var categoryDisplayName = (categoryFacet === null || categoryFacet === void 0 ? void 0 : categoryFacet.displayName) || "Categories";
    var categoryValues = (categoryFacet === null || categoryFacet === void 0 ? void 0 : categoryFacet.values) || [];
    var categoryItems = categoryValues.map(function(v) {
        return {
            label: "".concat(v.name, " (").concat(v.count, ")"),
            value: v.name
        };
    });
    var metalArray = (ref8 = categoryState === null || categoryState === void 0 ? void 0 : (ref5 = categoryState.facets) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.text) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.list) === null || ref7 === void 0 ? void 0 : ref7.find(function(x) {
        return x.facetName == "vPurity_uFilter";
    })) === null || ref8 === void 0 ? void 0 : ref8.values;
    var metalItems = (metalArray === null || metalArray === void 0 ? void 0 : metalArray.reduce(function(acc, cur, index) {
        if (index % 2 === 0) {
            acc.push({
                label: "".concat(cur, " (").concat(metalArray[index + 1], ")"),
                value: cur
            });
        }
        return acc;
    }, [])) || [];
    var occasionArray = (ref12 = categoryState === null || categoryState === void 0 ? void 0 : (ref9 = categoryState.facets) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.text) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.list) === null || ref11 === void 0 ? void 0 : ref11.find(function(x) {
        return x.facetName == "vOccasions_uFilter";
    })) === null || ref12 === void 0 ? void 0 : ref12.values;
    var occasionItems = (occasionArray === null || occasionArray === void 0 ? void 0 : occasionArray.reduce(function(acc, cur, index) {
        if (index % 2 === 0) {
            acc.push({
                label: "".concat(cur, " (").concat(occasionArray[index + 1], ")"),
                value: cur
            });
        }
        return acc;
    }, [])) || [];
    var handleCategoryChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(catName) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!catName || catName === "All Products")) {
                            _ctx.next = 3;
                            break;
                        }
                        router.push({
                            pathname: "/jewellery"
                        });
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return http_client/* default.get */.Z.get(endpoints/* default.products.categorySlugbyName */.Z.products.categorySlugbyName(catName));
                    case 6:
                        data = _ctx.sent.data;
                        if (data) {
                            router.push({
                                pathname: "/jewellery/category/".concat(data.slug)
                            });
                        }
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                        router.push({
                            pathname: "/jewellery",
                            query: {
                                category: catName
                            }
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10
                ]
            ]);
        }));
        return function handleCategoryChange(catName) {
            return _ref.apply(this, arguments);
        };
    }();
    var activeCategoryCount = activeCategory ? 1 : 0;
    var activePriceCount = activePriceLabel ? 1 : 0;
    var activeMetalCount = activeMetals.length;
    var handlePriceChange = function(value) {
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    priceMin: value.min,
                    priceMax: value.max
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
        } else {
            var ref;
            router.replace({
                pathname: "/jewellery/category/[category]",
                query: (0,_object_spread/* default */.Z)({
                    category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    priceMin: value.min,
                    priceMax: value.max
                })))
            }, undefined, {
                shallow: true
            });
        }
    };
    var handleMetalChange = function(metalVal) {
        var newMetals = (0,_to_consumable_array/* default */.Z)(activeMetals);
        if (newMetals.includes(metalVal)) {
            newMetals = newMetals.filter(function(m) {
                return m !== metalVal;
            });
        } else {
            newMetals.push(metalVal);
        }
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    metal: newMetals
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
        } else {
            var ref;
            router.replace({
                pathname: "/jewellery/category/[category]",
                query: (0,_object_spread/* default */.Z)({
                    category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    metal: newMetals
                })))
            }, undefined, {
                shallow: true
            });
        }
    };
    var sortFilterChange = function(value) {
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    sort: value
                }))), {
                    q: router.query.q,
                    try_it_online: router.query.try_it_online
                })
            }, undefined, {
                shallow: true
            });
        } else {
            var ref;
            router.replace({
                pathname: "/jewellery/category/[category]",
                query: (0,_object_spread/* default */.Z)({
                    category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    sort: value
                })))
            }, undefined, {
                shallow: true
            });
        }
        setShowSort(false);
    };
    var sortFilters = [
        {
            label: "Relevance",
            value: ""
        },
        {
            label: "Price: Low to High",
            value: "price-asc"
        },
        {
            label: "Price: High to Low",
            value: "price-desc"
        }, 
    ];
    var fastDeliveryChange = function(event) {
        var ref;
        if (isSearch) {
            router.replace({
                pathname: "/jewellery",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    fastDelivery: event.target.checked
                }))), {
                    q: router.query.q
                })
            }, undefined, {
                shallow: true
            });
            return;
        }
        router.replace({
            pathname: "/jewellery/category/[category]",
            query: (0,_object_spread/* default */.Z)({
                category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                fastDelivery: event.target.checked
            })))
        }, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((product_list_module_default()).container, " ", "container"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row mb-0 mt-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: isSearch && router.query.q && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Search results for '",
                            router.query.q,
                            "'"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (product_list_module_default()).desktop_filter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-100 display-fl align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "display-fl align-items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_filter_dropdown, {
                                            isSearch: isSearch
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "display-fl align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (product_list_module_default()).checkbox,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (product_list_module_default()).check,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: "fast_red pointer",
                                                            htmlFor: "fast-delivery-filter",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: (product_list_module_default()).fast,
                                                                    src: fast/* default */.Z,
                                                                    alt: ""
                                                                }),
                                                                " Fast Delivery"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (product_list_module_default())["switch"],
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    id: "fast-delivery-filter",
                                                                    type: "checkbox",
                                                                    checked: ((ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.fastDelivery) ? true : false,
                                                                    onChange: fastDeliveryChange
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "".concat((product_list_module_default()).slider, " ").concat((product_list_module_default()).round)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (product_list_module_default()).filter_section1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (product_list_module_default()).filter_section2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Sort By:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sort_filter, {
                                                            isSearch: isSearch
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-9",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-1 mt-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination_counter/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cleafix"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (product_list_module_default()).mobile_filter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (product_list_module_default()).filter_controls,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (product_list_module_default()).icon_btn,
                                onClick: function() {
                                    setShowFilter(!showFilter);
                                    setShowSort(false);
                                },
                                "aria-label": "Filter",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "1.5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (product_list_module_default()).icon_btn,
                                onClick: function() {
                                    setShowSort(!showSort);
                                    setShowFilter(false);
                                },
                                "aria-label": "Sort",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "15",
                                    height: "12",
                                    viewBox: "0 0 15 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M6.37934 3.5686L3.49045 0.601562L0.601562 3.5686M3.48794 10.6016V0.601562M13.6016 7.63453L10.7127 10.6016L7.82378 7.63453M10.7102 0.601562V10.6016",
                                        stroke: "#121212",
                                        strokeWidth: "1.2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (product_list_module_default()).active_chips,
                                children: [
                                    activeCategory && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (product_list_module_default()).chip,
                                        children: [
                                            activeCategory,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: clearCategory,
                                                children: "✕"
                                            })
                                        ]
                                    }),
                                    activePriceLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (product_list_module_default()).chip,
                                        children: [
                                            activePriceLabel,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: clearPrice,
                                                children: "✕"
                                            })
                                        ]
                                    }),
                                    activeMetals.map(function(metal) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (product_list_module_default()).chip,
                                            children: [
                                                metal,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    onClick: function() {
                                                        return clearMetal(metal);
                                                    },
                                                    children: "✕"
                                                })
                                            ]
                                        }, metal);
                                    }),
                                    activeOccasions.map(function(occ) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (product_list_module_default()).chip,
                                            children: [
                                                occ,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    onClick: function() {
                                                        return clearOccasion(occ);
                                                    },
                                                    children: "✕"
                                                })
                                            ]
                                        }, occ);
                                    }),
                                    hasAnyFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (product_list_module_default()).clear_all,
                                        onClick: clearAll,
                                        children: "Clear All"
                                    })
                                ]
                            })
                        ]
                    }),
                    showFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (product_list_module_default()).mobile_filter_overlay,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).mobile_filter_drawer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).drawer_header,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Filter By"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return setShowFilter(false);
                                            },
                                            "aria-label": "Close",
                                            className: (product_list_module_default()).close_btn,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "#333",
                                                strokeWidth: "2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M18 6L6 18M6 6L18 18",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).drawer_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (product_list_module_default()).fast_delivery_mobile,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (product_list_module_default()).airplane_wrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: fast/* default */.Z,
                                                            alt: "Fast Delivery",
                                                            width: 24,
                                                            height: 24
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Fast Delivery"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: (product_list_module_default()).mobile_switch,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: ((ref14 = router.query) === null || ref14 === void 0 ? void 0 : ref14.fastDelivery) ? true : false,
                                                            onChange: fastDeliveryChange
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "".concat((product_list_module_default()).slider, " ").concat((product_list_module_default()).round)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (product_list_module_default()).mobile_accordion,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (product_list_module_default()).accordion_title,
                                                    onClick: function() {
                                                        return toggleAccordion("categories");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                categoryDisplayName,
                                                                " (",
                                                                activeCategoryCount,
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "16",
                                                            height: "16",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            style: {
                                                                transform: openAccordions.includes("categories") ? "rotate(180deg)" : "none",
                                                                transition: "0.3s"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M6 9L12 15L18 9",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                openAccordions.includes("categories") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (product_list_module_default()).accordion_body,
                                                    children: categoryItems.map(function(cat) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (product_list_module_default()).mobile_checkbox_row,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: activeCategory === cat.value,
                                                                    onChange: function() {
                                                                        return handleCategoryChange(cat.value);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: cat.label
                                                                })
                                                            ]
                                                        }, cat.value);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (product_list_module_default()).mobile_accordion,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (product_list_module_default()).accordion_title,
                                                    onClick: function() {
                                                        return toggleAccordion("price");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                "Price (",
                                                                activePriceCount,
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "16",
                                                            height: "16",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            style: {
                                                                transform: openAccordions.includes("price") ? "rotate(180deg)" : "none",
                                                                transition: "0.3s"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M6 9L12 15L18 9",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                openAccordions.includes("price") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (product_list_module_default()).accordion_body,
                                                    children: priceFilters.map(function(p) {
                                                        var isChecked = activePriceLabel === p.label;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (product_list_module_default()).mobile_checkbox_row,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: isChecked,
                                                                    onChange: function() {
                                                                        if (isChecked) clearPrice();
                                                                        else handlePriceChange(p.value);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: p.label
                                                                })
                                                            ]
                                                        }, p.label);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (product_list_module_default()).mobile_accordion,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (product_list_module_default()).accordion_title,
                                                    onClick: function() {
                                                        return toggleAccordion("metal");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                "Metal (",
                                                                activeMetalCount,
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "16",
                                                            height: "16",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            style: {
                                                                transform: openAccordions.includes("metal") ? "rotate(180deg)" : "none",
                                                                transition: "0.3s"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M6 9L12 15L18 9",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                openAccordions.includes("metal") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (product_list_module_default()).accordion_body,
                                                    children: metalItems.map(function(m) {
                                                        var isChecked = activeMetals.includes(m.value);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (product_list_module_default()).mobile_checkbox_row,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: isChecked,
                                                                    onChange: function() {
                                                                        return handleMetalChange(m.value);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: m.label
                                                                })
                                                            ]
                                                        }, m.value);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (product_list_module_default()).mobile_accordion,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (product_list_module_default()).accordion_title,
                                                    onClick: function() {
                                                        return toggleAccordion("occasion");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                "Occasion (",
                                                                activeOccasions.length,
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "16",
                                                            height: "16",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            style: {
                                                                transform: openAccordions.includes("occasion") ? "rotate(180deg)" : "none",
                                                                transition: "0.3s"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M6 9L12 15L18 9",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                openAccordions.includes("occasion") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (product_list_module_default()).accordion_body,
                                                    children: occasionItems.map(function(m) {
                                                        var isChecked = activeOccasions.includes(m.value);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                            className: (product_list_module_default()).mobile_checkbox_row,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: isChecked,
                                                                    onChange: function() {
                                                                        return handleOccasionChange(m.value);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: m.label
                                                                })
                                                            ]
                                                        }, m.value);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (product_list_module_default()).drawer_footer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: (product_list_module_default()).clear_all_btn,
                                                onClick: clearAll,
                                                children: "Clear All"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    showSort && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (product_list_module_default()).mobile_filter_overlay,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((product_list_module_default()).mobile_filter_drawer, " ").concat((product_list_module_default()).sort_drawer),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).drawer_header,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Sort By"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return setShowSort(false);
                                            },
                                            "aria-label": "Close",
                                            className: (product_list_module_default()).close_btn,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "#333",
                                                strokeWidth: "2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M18 6L6 18M6 6L18 18",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).drawer_content,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).sort_list,
                                        children: sortFilters.map(function(sort) {
                                            var isSelected = (router.query.sort || "") === sort.value;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "".concat((product_list_module_default()).sort_option, " ").concat(isSelected ? (product_list_module_default()).active_sort : ""),
                                                onClick: function() {
                                                    return sortFilterChange(sort.value);
                                                },
                                                children: sort.label
                                            }, sort.value);
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: ((ref15 = categoryState.products) === null || ref15 === void 0 ? void 0 : ref15.data) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-1 mt-3",
                            children: [
                                "Showing 1 -",
                                " ",
                                categoryState.products.size * (categoryState.products.page - 1) + categoryState.products.data.length,
                                " ",
                                "of ",
                                categoryState.products.totalRecords
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var filters = (CatgeoryFiltersUnbxd);


/***/ }),

/***/ 43977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _store_slices_category__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10328);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);




var PaginationCounterUnbxd = function() {
    var ref, ref1, ref2;
    var categoryState = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_slices_category__WEBPACK_IMPORTED_MODULE_1__/* .selectCategory */ .uY);
    if ((ref = categoryState.products) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
        var ref3, ref4, ref5, ref6, ref7;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Showing 1 - ",
                (ref3 = categoryState.products) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.products) === null || ref5 === void 0 ? void 0 : ref5.length,
                " of",
                " ",
                (ref6 = categoryState.products) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.response) === null || ref7 === void 0 ? void 0 : ref7.numberOfProducts
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (PaginationCounterUnbxd);


/***/ }),

/***/ 74646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_list; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/components/product-card/product-card-skeleton.tsx
var product_card_skeleton = __webpack_require__(35098);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 7 modules
var Accordion = __webpack_require__(5607);
// EXTERNAL MODULE: ./src/store/slices/category.ts
var category = __webpack_require__(10328);
// EXTERNAL MODULE: ./src/styles/product_list.module.scss
var product_list_module = __webpack_require__(79356);
var product_list_module_default = /*#__PURE__*/__webpack_require__.n(product_list_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/category-unbxd/breadcrumb/breadcrumb.tsx
var breadcrumb = __webpack_require__(42820);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/combineCategoryFilters.ts
var combineCategoryFilters = __webpack_require__(48825);
// EXTERNAL MODULE: ./src/image-loaders/s3-image-loader.ts
var s3_image_loader = __webpack_require__(78513);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./src/assets/images/cart1.svg
var cart1 = __webpack_require__(18676);
// EXTERNAL MODULE: ./src/lib/ga4.ts
var ga4 = __webpack_require__(77981);
// EXTERNAL MODULE: ./node_modules/@tippyjs/react/dist/tippy-react.esm.js + 3 modules
var tippy_react_esm = __webpack_require__(81246);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/assets/images/fast.svg
var fast = __webpack_require__(37726);
// EXTERNAL MODULE: ./src/components/common/currency-inr.tsx
var currency_inr = __webpack_require__(76630);
// EXTERNAL MODULE: ./src/components/common/loading-spinner.tsx + 1 modules
var loading_spinner = __webpack_require__(74043);
// EXTERNAL MODULE: ./src/components/common/loading-spinner-small.tsx + 1 modules
var loading_spinner_small = __webpack_require__(66091);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(92814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.es.js
var free_regular_svg_icons_index_es = __webpack_require__(56024);
// EXTERNAL MODULE: ./src/store/slices/wishlist.ts
var wishlist = __webpack_require__(78271);
// EXTERNAL MODULE: ./src/lib/fpixel.ts
var fpixel = __webpack_require__(50634);
// EXTERNAL MODULE: ./src/lib/ppixel.ts
var ppixel = __webpack_require__(55763);
// EXTERNAL MODULE: ./src/lib/tryOnTracking.ts
var tryOnTracking = __webpack_require__(68763);
// EXTERNAL MODULE: ./src/components/similar-product/similar-product.tsx + 3 modules
var similar_product = __webpack_require__(9556);
// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
;// CONCATENATED MODULE: ./src/components/product-card-unbxd/product-card.tsx































var ProductCardUnbxd = function(param) {
    var product = param.product;
    var ref, ref1, ref2, ref3, ref4;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref5 = (0,react.useState)(false), cartAddLoading = ref5[0], setCartAddLoading = ref5[1];
    var ref6 = (0,react.useState)(false), cartRemoveLoading = ref6[0], setCartRemoveLoading = ref6[1];
    var ref7 = (0,react.useState)(false), wishlistActionLoading = ref7[0], setwishlistActionLoading = ref7[1];
    var ref8 = (0,react.useState)({
        type: "",
        id: ""
    }), actionData = ref8[0], setActionData = ref8[1];
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var actionInProgress = (0,react.useRef)(false);
    var ref9 = (0,react.useState)(false), tryOnAddToCart = ref9[0], setTryOnAddToCart = ref9[1];
    var ref10 = (0,react.useState)(false), tryOnRemoveFromCart = ref10[0], setTryOnRemoveFromCart = ref10[1];
    var ref11 = (0,react.useState)(false), similarLoading = ref11[0], setSimilarLoading = ref11[1];
    var ref12 = (0,react.useState)(((ref2 = (ref1 = (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(v) {
        return v.id === "tags";
    })) === null || ref1 === void 0 ? void 0 : ref1.values[0]) === null || ref2 === void 0 ? void 0 : ref2.value[0]) || ""), tags = ref12[0], setTags = ref12[1];
    var priceId = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (ref2 = (ref1 = (ref = product.attributes) === null || ref === void 0 ? void 0 : ref.find(function(v) {
            return v.id === "price_id";
        })) === null || ref1 === void 0 ? void 0 : ref1.values[0]) === null || ref2 === void 0 ? void 0 : ref2.value[0];
    }, [
        product.attributes
    ]);
    var cartItem = (0,react.useMemo)(function() {
        return cartState.items.find(function(v) {
            return v.identifier === product.defaultVariantId;
        }) || null;
    }, [
        cartState.items,
        product.defaultVariantId
    ]);
    var wishlistItem = (0,react.useMemo)(function() {
        return wishlistState.items.find(function(v) {
            return v.id == product.productId;
        }) || null;
    }, [
        wishlistState.items,
        product.productId
    ]);
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!cartAddLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        setActionData({
                            type: "cart",
                            id: product.defaultVariantId
                        });
                        sessionStorage.setItem("add-to-cart-or-wishlist-id", product.defaultVariantId);
                        return _ctx.abrupt("return");
                    case 7:
                        setCartAddLoading(true);
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            is_solitaire: false,
                            type: "product",
                            identifier: product.defaultVariantId
                        });
                    case 12:
                        _ctx.next = 14;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 14:
                        (0,react_toastify_esm/* toast */.Am)("Item added in cart", {
                            type: "success",
                            toastId: "cart-add-success"
                        });
                        (0,fpixel/* fbqTrackEvent */.dK)("AddToCart", {
                            content_type: "product",
                            content_ids: [
                                product.sku
                            ]
                        });
                        (0,ppixel/* ptrackEvent */.rn)("addtocart", {
                            event_id: "atc_".concat(Date.now()),
                            value: product.sellingPrice,
                            order_quantity: 1,
                            currency: "INR"
                        });
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to cart ", {
                                source: "web",
                                platform: "senco",
                                prid: product.productId,
                                variant_id: product.defaultVariantId,
                                image: product.imageUrl[0],
                                prqt: 1,
                                product_name: product.title,
                                amount: product.sellingPrice,
                                product_url: product.productUrl,
                                discounted_price: product.sellingPrice !== product.price ? product.sellingPrice : 0,
                                stock_availability: 1
                            });
                        }
                        window.dataLayer.push({
                            ecommerce: null
                        });
                        window.dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                currency: "INR",
                                value: product.sellingPrice,
                                items: [
                                    {
                                        item_id: (product === null || product === void 0 ? void 0 : product.sku) || (product === null || product === void 0 ? void 0 : product.productId),
                                        item_name: product.title,
                                        item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                                        item_category: product.categories && product.categories.length ? (ref = (0,_to_consumable_array/* default */.Z)(product.categories).reverse()[0]) === null || ref === void 0 ? void 0 : ref.name : "",
                                        item_variant: product.purity || ((ref3 = (ref2 = (ref1 = product.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
                                            return v.id === "purity";
                                        })) === null || ref2 === void 0 ? void 0 : ref2.values[0]) === null || ref3 === void 0 ? void 0 : ref3.value[0]) || product.defaultVariantId,
                                        price: product.sellingPrice,
                                        quantity: 1
                                    }, 
                                ]
                            }
                        });
                        _ctx.next = 24;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](8);
                    case 24:
                        setCartAddLoading(false);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    22
                ]
            ]);
        }));
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref13 = (0,react.useState)(false), show = ref13[0], setShow = ref13[1];
    var ref14 = (0,react.useState)([]), skus = ref14[0], setskus = ref14[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var formdata, data, filteredImages, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSimilarLoading(true);
                        formdata = new FormData();
                        formdata.append("image_url", product.imageUrl[0]);
                        formdata.append("tags", "[\"senco\"]" || 0);
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return http_client/* default.post */.Z.post(endpoints/* default.products.similarproduct */.Z.products.similarproduct(), formdata);
                    case 7:
                        data = _ctx.sent.data;
                        filteredImages = data.images.filter(function(v) {
                            return v.distance > 0.65;
                        });
                        _ctx.next = 11;
                        return setskus(filteredImages.map(function(v) {
                            return v.product_id;
                        }));
                    case 11:
                        setShow(true);
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                        (0,react_toastify_esm/* toast */.Am)(((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) || "No products found", {
                            type: "error",
                            toastId: "coupon-otp-error"
                        });
                    case 18:
                        _ctx.prev = 18;
                        setSimilarLoading(false);
                        return _ctx.finish(18);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    14,
                    18,
                    21
                ]
            ]);
        }));
        return function handleShow() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref15 = (0,react.useState)(false), isOpen = ref15[0], setIsOpen = ref15[1];
    (0,react.useEffect)(function() {
        if (tryOnAddToCart) {
            setTryOnAddToCart(false);
            addToCart();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tryOnAddToCart
    ]);
    var removeFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var requireConfirmation, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        requireConfirmation = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                        if (!requireConfirmation) {
                            _ctx.next = 4;
                            break;
                        }
                        if (confirm("Are you sure you want to remove this product from cart?")) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        setCartRemoveLoading(true);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id));
                    case 8:
                        _ctx.next = 10;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 10:
                        (0,react_toastify_esm/* toast */.Am)("Item removed from cart", {
                            type: "info",
                            toastId: "cart-remove-success"
                        });
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Remove from cart ", {
                                source: "web",
                                platform: "senco",
                                prid: product.productId,
                                variant_id: product.defaultVariantId,
                                image: product.imageUrl[0],
                                prqt: 1,
                                product_name: product.title,
                                amount: product.sellingPrice,
                                product_url: product.productUrl
                            });
                        }
                        if (product.categories && product.categories.length) {
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: "remove_from_cart",
                                ecommerce: {
                                    currency: "INR",
                                    value: product.discount ? product.discount.price : product.price,
                                    items: [
                                        {
                                            item_id: product === null || product === void 0 ? void 0 : product.sku,
                                            item_name: product.title,
                                            item_category: (0,_to_consumable_array/* default */.Z)(product.categories).reverse()[0].name,
                                            price: product.discount ? product.discount.price : product.price,
                                            quantity: 1
                                        }, 
                                    ]
                                }
                            });
                        }
                        _ctx.next = 18;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                    case 18:
                        setCartRemoveLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    15
                ]
            ]);
        }));
        return function removeFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (tryOnRemoveFromCart) {
            setTryOnRemoveFromCart(false);
            removeFromCart(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tryOnRemoveFromCart
    ]);
    var openTryOn = function() {
        if (window.initMirrarUI && "e517b5d3-15f1-4d2c-87a7-ecb16d0d151f") {
            (0,tryOnTracking/* initTryOnEventListener */.K)(function(name, data) {
                if (name == "add-to-cart") {
                    if (data.productCode == String(product.sku).toUpperCase()) {
                        setTryOnAddToCart(true);
                    }
                }
                if (name == "ProductRemoveFromCart") {
                    if (data.productCode == String(product.sku).toUpperCase()) {
                        setTryOnRemoveFromCart(true);
                    }
                }
            });
            window.initMirrarUI(String(product.sku).toUpperCase(), {
                brandId: "e517b5d3-15f1-4d2c-87a7-ecb16d0d151f"
            });
            if (product.categories && product.categories.length) {
                window.gtag("event", "tryon-button-click", {
                    event_category: "mirrar-internal-event",
                    event_label: "".concat((0,_to_consumable_array/* default */.Z)(product.categories).reverse()[0].name, "/").concat(product.sku, "/").concat(product.discount ? product.discount.total : product.price)
                });
            }
        }
    };
    var addToWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!wishlistActionLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        sessionStorage.setItem("add-to-cart-or-wishlist-id", product.groupId ? product.groupId : product.productId);
                        setActionData({
                            type: "wishlist",
                            id: product.groupId ? product.groupId : product.productId
                        });
                        return _ctx.abrupt("return");
                    case 7:
                        setwishlistActionLoading(true);
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.add */.Z.wishlist.add(), {
                            product_id: product.groupId ? product.groupId : product.productId,
                            user_id: authState.user.id
                        });
                    case 11:
                        _ctx.next = 13;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 13:
                        (0,react_toastify_esm/* toast */.Am)("Item added in wishlist", {
                            type: "success",
                            toastId: "withlist-add-success"
                        });
                        (0,fpixel/* fbqTrackEvent */.dK)("AddToWishlist", {
                            content_type: "product",
                            content_ids: [
                                product.sku[0]
                            ]
                        });
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to wishlist ", {
                                source: "web",
                                platform: "senco",
                                prid: product.groupId ? product.groupId : product.productId,
                                variant_id: product.defaultVariantId,
                                image: product.imageUrl[0],
                                prqt: 1,
                                product_name: product.title,
                                amount: product.price,
                                product_url: product.productUrl,
                                discounted_price: product.sellingPrice !== product.price ? product.sellingPrice : 0,
                                stock_availability: 1
                            });
                        }
                        _ctx.next = 20;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](8);
                    case 20:
                        setwishlistActionLoading(false);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    18
                ]
            ]);
        }));
        return function addToWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFromWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!wishlistActionLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (confirm("Are you sure you want to remove this product from wishlist?")) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 7:
                        setwishlistActionLoading(true);
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.remove */.Z.wishlist.remove(), {
                            product_id: product.productId,
                            user_id: authState.user.id
                        });
                    case 11:
                        _ctx.next = 13;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 13:
                        (0,react_toastify_esm/* toast */.Am)("Item removed from wishlist", {
                            type: "success",
                            toastId: "withlist-remove-success"
                        });
                        _ctx.next = 18;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](8);
                    case 18:
                        setwishlistActionLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    16
                ]
            ]);
        }));
        return function removeFromWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var handleAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!actionInProgress.current) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            if (!(actionData.id && authState.user)) {
                                _ctx.next = 23;
                                break;
                            }
                            actionInProgress.current = true;
                            _ctx.prev = 4;
                            if (!(actionData.type === "cart")) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 8;
                            return addToCart();
                        case 8:
                            _ctx.next = 13;
                            break;
                        case 10:
                            if (!(actionData.type === "wishlist")) {
                                _ctx.next = 13;
                                break;
                            }
                            _ctx.next = 13;
                            return addToWishlist();
                        case 13:
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](4);
                            ;
                        case 18:
                            _ctx.prev = 18;
                            setActionData({
                                type: "",
                                id: ""
                            });
                            sessionStorage.removeItem("add-to-cart-or-wishlist-id");
                            actionInProgress.current = false;
                            return _ctx.finish(18);
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        15,
                        18,
                        23
                    ]
                ]);
            }));
            return function handleAction() {
                return _ref.apply(this, arguments);
            };
        }();
        var cart_id = sessionStorage.getItem("add-to-cart-or-wishlist-id");
        if ("".concat(actionData === null || actionData === void 0 ? void 0 : actionData.id) === cart_id && authState.user) {
            handleAction();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        authState,
        actionData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((product_list_module_default()).product, " product-info-sku-variant"),
                "data-sku": product.sku,
                "data-variant-id": product.sku,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (product_list_module_default()).pad_10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).products_text_top,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).product_top_left,
                                    children: [
                                        product.isBestSeller === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (product_list_module_default()).best_seller,
                                            children: "BESTSELLER"
                                        }),
                                        product.isNewArrival === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (product_list_module_default()).new_arrival,
                                            children: "NEW ARRIVAL"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).cart_top,
                                    children: [
                                        ((ref3 = product.variants[0]) === null || ref3 === void 0 ? void 0 : ref3.vIsFastDelivery) && ((ref4 = product.variants[0]) === null || ref4 === void 0 ? void 0 : ref4.vIsFastDelivery) === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                            content: "Fast Delivery",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (product_list_module_default()).fast_delivery,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: fast/* default */.Z,
                                                    alt: "Fast Delivery",
                                                    priority: true,
                                                    unoptimized: true
                                                })
                                            })
                                        }),
                                        wishlistActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                position: "relative",
                                                top: -6
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner_small/* default */.Z, {})
                                        }),
                                        !wishlistActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: wishlistItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                                content: "Wishlisted",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "pointer",
                                                    onClick: removeFromWishlist,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faHeart */.m6i,
                                                        width: 20,
                                                        color: "rgba(143, 0, 6, 1)",
                                                        style: {
                                                            position: "relative",
                                                            top: -8
                                                        }
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                                content: "Add To Wishlist",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "pointer",
                                                    onClick: addToWishlist,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_regular_svg_icons_index_es/* faHeart */.m6i,
                                                        width: 20,
                                                        color: "rgba(143, 0, 6, 1)",
                                                        style: {
                                                            position: "relative",
                                                            top: -8
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: product.productUrl,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).product_image,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: product.imageUrl[0],
                                        alt: product.title,
                                        width: 2500,
                                        height: 2500,
                                        className: (product_list_module_default()).img_fluid
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((product_list_module_default()).discount_container, " ").concat(product.discountLabel ? "has-product-discount" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (product_list_module_default()).discount_text,
                                children: "\xa0"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((product_list_module_default()).similar_button_container_over, " ").concat((product_list_module_default()).center_single),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return handleShow();
                                },
                                className: (product_list_module_default()).similar_button,
                                children: similarLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).buttonLoader,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontSize: "14px",
                                                fontWeight: "400",
                                                lineHeight: "1",
                                                marginLeft: "8px",
                                                whiteSpace: "nowrap"
                                            },
                                            children: "Loading..."
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M4.15784 14.6486C2.55606 14.7333 1.43008 13.4626 1.35838 12.4253L0.607516 3.95596C0.50054 2.40826 1.8481 1.07773 3.61737 0.984153L8.43732 0.611263C10.0391 0.526541 11.3047 0.984153 11.6469 2.48291M13.4852 3.0382L7.5354 3.0382C5.81428 3.0382 4.41904 4.43489 4.41904 6.15779L4.41903 13.482C4.41903 15.2049 5.81428 16.6016 7.5354 16.6016H13.4852C15.2063 16.6016 16.6016 15.2049 16.6016 13.482L16.6016 6.1578C16.6016 4.43489 15.2063 3.0382 13.4852 3.0382Z",
                                                stroke: "currentColor",
                                                strokeWidth: "1.2",
                                                strokeLinecap: "round"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (product_list_module_default()).span,
                                            children: "Similar"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (product_list_module_default()).product_text_d,
                            children: product.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).price_cart,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).price1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                value: product.sellingPrice
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (product_list_module_default()).price2,
                                            children: product.sellingPrice !== product.price ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                    value: product.price
                                                })
                                            }) : "\xa0"
                                        })
                                    ]
                                }),
                                !cartItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        cartAddLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {}),
                                        !cartAddLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                            content: "Add To Cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "".concat((product_list_module_default()).details, " pointer"),
                                                onClick: addToCart,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: cart1/* default */.Z,
                                                    alt: "Add To Cart",
                                                    width: 26,
                                                    height: 26
                                                })
                                            })
                                        })
                                    ]
                                }),
                                cartItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        cartRemoveLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {}),
                                        !cartRemoveLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(tippy_react_esm/* default */.ZP, {
                                            content: "Remove From Cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "".concat((product_list_module_default()).details, " pointer"),
                                                onClick: function() {
                                                    return removeFromCart();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: cart1/* default */.Z,
                                                    alt: "Add To Cart",
                                                    width: 26,
                                                    height: 26
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(similar_product/* default */.Z, {
                show: show,
                handleClose: handleClose,
                setIsOpen: setIsOpen,
                isOpen: isOpen,
                image: product.imageUrl[0],
                skus: skus,
                setskus: setskus
            })
        ]
    });
};
/* harmony default export */ var product_card = (ProductCardUnbxd);

// EXTERNAL MODULE: ./src/components/category-unbxd/pagination-counter/pagination-counter.tsx
var pagination_counter = __webpack_require__(43977);
;// CONCATENATED MODULE: ./src/components/category-unbxd/products-list/products-list.tsx





















var CategoryProductsListUnbxd = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    ;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var isTryOnLanding = router.route === "/jewellery" && ((ref = router.query) === null || ref === void 0 ? void 0 : ref.try_it_online) === "yes" && !((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.q);
    ;
    var apiFilterQuery = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var filter = {
            // page: 1,
            productsCount: 20,
            currency: "",
            getAllVariants: "false",
            showOOSProductsInOrder: "false",
            attributeFacetValuesLimit: 20
        };
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.fastDelivery) {
            filter["fast_delivery"] = [
                "true"
            ];
        }
        if ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.try_it_online) {
            filter["try_online"] = [
                "true"
            ];
        }
        if ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metal) === null || ref3 === void 0 ? void 0 : ref3.length) {
            var ref10, ref11, ref12;
            filter["purity"] = typeof ((ref10 = router.query) === null || ref10 === void 0 ? void 0 : ref10.metal) !== "string" ? (ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.metal : [
                (ref12 = router.query) === null || ref12 === void 0 ? void 0 : ref12.metal
            ];
        }
        if ((ref4 = router.query) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.occasion) === null || ref5 === void 0 ? void 0 : ref5.length) {
            var ref13, ref14, ref15;
            filter["occasions"] = typeof ((ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.occasion) !== "string" ? (ref14 = router.query) === null || ref14 === void 0 ? void 0 : ref14.occasion : [
                (ref15 = router.query) === null || ref15 === void 0 ? void 0 : ref15.occasion
            ];
        }
        if (((ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.priceMin) || ((ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.priceMax)) {
            var ref16, ref17;
            filter.sellingPrice = {
                lte: ((ref16 = router.query) === null || ref16 === void 0 ? void 0 : ref16.priceMax) || 99999999999,
                gte: ((ref17 = router.query) === null || ref17 === void 0 ? void 0 : ref17.priceMin) || 0
            };
        }
        if ((ref8 = router.query) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sort) === null || ref9 === void 0 ? void 0 : ref9.length) {
            var ref18;
            filter.sort = ((ref18 = router.query) === null || ref18 === void 0 ? void 0 : ref18.sort) == "price-asc" ? "sellingPrice asc" : "sellingPrice desc";
        } else {
            if (router.route == "/jewellery") {
                var ref19;
                if (((ref19 = router.query) === null || ref19 === void 0 ? void 0 : ref19.try_it_online) == "yes") {
                    filter.sort = [
                        {
                            field: "priority:float",
                            order: "asc"
                        },
                        {
                            field: "sellingPrice",
                            order: "asc"
                        }, 
                    ];
                } else {
                // filter.sort =
                //   router.query?.sort == "price-asc"
                //     ? "sellingPrice asc"
                //     : "sellingPrice desc";
                }
            } else {
            //   filter.sort =
            //     router.query?.sort == "price-asc"
            //       ? "sellingPrice asc"
            //       : "sellingPrice desc";
            // }
            }
        // filter.sort = "priority asc";
        }
        return filter;
    };
    var ref22 = (0,react.useState)(false), isSearch = ref22[0], setIsSearch = ref22[1];
    var ref23 = (0,react.useState)(false), isFetching = ref23[0], setIsFetching = ref23[1];
    var hasMore = !!(categoryState.products && ((ref2 = categoryState.products) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : ref3.products.length) < ((ref4 = categoryState.products) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.response) === null || ref5 === void 0 ? void 0 : ref5.numberOfProducts));
    var loadMore = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(isFetching || categoryState.productsLoading || !hasMore)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    setIsFetching(true);
                    _ctx.prev = 3;
                    if (!categoryState.products) {
                        _ctx.next = 21;
                        break;
                    }
                    if (!isSearch) {
                        _ctx.next = 11;
                        break;
                    }
                    ;
                    _ctx.next = 9;
                    return dispatch((0,category/* fetchMoreSearchProductsByUnbxd */.db)({
                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            page: ((ref = categoryState.products) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.start) !== 0 ? Number((((ref2 = categoryState.products) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : ref3.start) + 20) / 20) + 1 : 2,
                            search: router.query.q
                        }, apiFilterQuery()), {
                            q: router.query.q,
                            searchedKey: (ref4 = categoryState.products.filters) === null || ref4 === void 0 ? void 0 : ref4.searchedKey
                        })
                    }));
                case 9:
                    _ctx.next = 21;
                    break;
                case 11:
                    if (!(categoryState.data && !isTryOnLanding)) {
                        _ctx.next = 17;
                        break;
                    }
                    ;
                    _ctx.next = 15;
                    return dispatch((0,category/* fetchMoreCategoryProductsByUnbxd */.pt)({
                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            page: ((ref5 = categoryState.products) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.response) === null || ref6 === void 0 ? void 0 : ref6.start) !== 0 ? Number((((ref7 = categoryState.products) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.response) === null || ref8 === void 0 ? void 0 : ref8.start) + 20) / 20) + 1 : 2
                        }, apiFilterQuery()), {
                            categoryPath: categoryState.mapping.length ? categoryState.mapping.map(function(item) {
                                return item.name;
                            }).join(">") + ">".concat((ref9 = categoryState.data) === null || ref9 === void 0 ? void 0 : ref9.name) : (ref10 = categoryState.data) === null || ref10 === void 0 ? void 0 : ref10.name,
                            categories: String((ref11 = categoryState.data) === null || ref11 === void 0 ? void 0 : ref11.id),
                            searchedKey: (ref12 = categoryState.products.filters) === null || ref12 === void 0 ? void 0 : ref12.searchedKey
                        })
                    }));
                case 15:
                    _ctx.next = 21;
                    break;
                case 17:
                    if (!isTryOnLanding) {
                        _ctx.next = 21;
                        break;
                    }
                    ;
                    _ctx.next = 21;
                    return dispatch((0,category/* fetchMoreCategoryProductsByUnbxd */.pt)({
                        query: (0,_object_spread/* default */.Z)({
                            page: ((ref13 = categoryState.products) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.response) === null || ref14 === void 0 ? void 0 : ref14.start) !== 0 ? Number((((ref15 = categoryState.products) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.response) === null || ref16 === void 0 ? void 0 : ref16.start) + 20) / 20) + 1 : 2,
                            try_online: true
                        }, apiFilterQuery())
                    }));
                case 21:
                    _ctx.next = 26;
                    break;
                case 23:
                    _ctx.prev = 23;
                    _ctx.t0 = _ctx["catch"](3);
                    ;
                case 26:
                    _ctx.prev = 26;
                    setIsFetching(false);
                    return _ctx.finish(26);
                case 29:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                23,
                26,
                29
            ]
        ]);
    })), [
        isFetching,
        categoryState.productsLoading,
        hasMore,
        categoryState.products,
        categoryState.data,
        categoryState.mapping,
        isSearch,
        isTryOnLanding,
        router.query,
        dispatch, 
    ]);
    var observerRef = (0,react.useRef)(null);
    var bottomRef = (0,react.useCallback)(function(node) {
        if (observerRef.current) observerRef.current.disconnect();
        if (!node) return;
        observerRef.current = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting && hasMore && !isFetching && !categoryState.productsLoading) {
                loadMore();
            }
        }, {
            rootMargin: "200px"
        });
        observerRef.current.observe(node);
    }, [
        loadMore,
        hasMore,
        isFetching,
        categoryState.productsLoading
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, []);
    (0,react.useEffect)(function() {
        if (categoryState.data) {
            if (!router.query.sort && [
                "bangle-utsav-collection-2023"
            ].includes(categoryState.data.slug)) {
                var ref;
                router.replace({
                    pathname: "/jewellery/category/[category]",
                    query: (0,_object_spread/* default */.Z)({
                        category: (ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug
                    }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        sort: "price-asc"
                    })))
                }, undefined, {
                    shallow: true
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        categoryState.data,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        ;
        if (!isTryOnLanding) {
            if (router.route == "/jewellery") {
                var ref, ref1, ref2, ref3, ref4, ref5;
                setIsSearch(true);
                if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.fastDelivery) || ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.sort) || ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.occasion) || ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.metal) || ((ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.priceMax) || ((ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.priceMin)) {
                    var ref6, ref7;
                    ;
                    dispatch((0,category/* fetchSearchProductByunbxd */.EE)({
                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiFilterQuery()), {
                            search: router.query.q,
                            q: router.query.q,
                            searchedKey: (ref6 = categoryState.products) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.filters) === null || ref7 === void 0 ? void 0 : ref7.searchedKey
                        })
                    }));
                } else {
                    var ref8, ref9;
                    ;
                    dispatch((0,category/* fetchSearchProductByunbxd */.EE)({
                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiFilterQuery()), {
                            search: router.query.q,
                            q: router.query.q,
                            searchedKey: (ref8 = categoryState.products) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.filters) === null || ref9 === void 0 ? void 0 : ref9.searchedKey
                        })
                    }));
                }
            } else {
                ;
                if (categoryState.data && !categoryState.mappingLoading) {
                    if (!router.query.sort && [
                        "bangle-utsav-collection-2023"
                    ].includes(categoryState.data.slug)) {
                        var ref10;
                        router.replace({
                            pathname: "/jewellery/category/[category]",
                            query: (0,_object_spread/* default */.Z)({
                                category: (ref10 = categoryState.data) === null || ref10 === void 0 ? void 0 : ref10.slug
                            }, (0,combineCategoryFilters/* combineCategoryFilters */.T)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                sort: "price-asc"
                            })))
                        }, undefined, {
                            shallow: true
                        });
                    } else {
                        var ref11, ref12, ref13;
                        ;
                        dispatch((0,category/* fetchCategoryFiltersByUnbxd */.I8)({
                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                tryItOnline: router.query.try_it_online
                            }, apiFilterQuery()), {
                                categoryPath: categoryState.mapping.length ? categoryState.mapping.map(function(item) {
                                    return item.name;
                                }).join(">") + ">".concat((ref11 = categoryState.data) === null || ref11 === void 0 ? void 0 : ref11.name) : (ref12 = categoryState.data) === null || ref12 === void 0 ? void 0 : ref12.name,
                                categories: String((ref13 = categoryState.data) === null || ref13 === void 0 ? void 0 : ref13.id)
                            })
                        }));
                    }
                }
            }
        } else {
            dispatch((0,category/* fetchCategoryFiltersByUnbxd */.I8)({
                query: (0,_object_spread/* default */.Z)({
                    try_online: true
                }, apiFilterQuery())
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.fastDelivery,
        (ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.try_it_online,
        (ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.sort,
        (ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.occasion,
        (ref10 = router.query) === null || ref10 === void 0 ? void 0 : ref10.metal,
        (ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.priceMax,
        (ref12 = router.query) === null || ref12 === void 0 ? void 0 : ref12.priceMin,
        router.query.q,
        router.query.category,
        categoryState.mapping,
        !isTryOnLanding, 
    ]);
    // Track GA4 view_item_list event when products load
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (((ref = categoryState.products) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.products) && categoryState.products.response.products.length > 0 && !categoryState.productsLoading) {
            ;
            var items = categoryState.products.response.products.map(function(product, index) {
                var ref;
                return {
                    item_id: product.uniqueId || String(product.productId),
                    item_name: product.title,
                    item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                    item_category: product.categoryPath1 ? (ref = product.categoryPath1.split(">").pop()) === null || ref === void 0 ? void 0 : ref.trim() : undefined,
                    price: product.sellingPrice || product.price,
                    quantity: 1,
                    index: index
                };
            });
            if (isSearch) {
                // Search results page
                (0,ga4/* trackViewItemList */.Mk)({
                    item_list_id: "search_results",
                    item_list_name: "Search: ".concat(router.query.q || ""),
                    items: items
                });
            } else if (categoryState.data) {
                // Category page
                (0,ga4/* trackViewItemList */.Mk)({
                    item_list_id: "category_".concat(categoryState.data.id),
                    item_list_name: categoryState.data.name || categoryState.data.title,
                    items: items
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref13 = categoryState.products) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.response) === null || ref14 === void 0 ? void 0 : ref14.products,
        categoryState.productsLoading,
        isSearch,
        categoryState.data, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((product_list_module_default()).container, " ", "container"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row g-3",
                children: [
                    categoryState.productsLoading && new Array(8).fill(1).map(function(_, k) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_skeleton/* default */.Z, {})
                        }, k);
                    }),
                    ((ref15 = categoryState.products) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.response) === null || ref16 === void 0 ? void 0 : ref16.products) && categoryState.products.response.products.map(function(product, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
                        // <Fragment key={product.sku}>
                        //   {index == 10 && categoryState.data?.inner_banner_1 && (
                        //     <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
                        //       <div
                        //         className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
                        //       >
                        //         <Image
                        //           src={categoryState.data?.inner_banner_1}
                        //           layout="fill"
                        //           alt="Inner banner 1"
                        //           priority
                        //           width={696}
                        //           height={589}
                        //           sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
                        //           loader={S3ImageLoader}
                        //         />
                        //       </div>
                        //     </div>
                        //   )}
                        //   {/* mobile banner 1 */}
                        //   {index == 10 && categoryState.data?.mob_inner_banner_1 && (
                        //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                        //       <a className={styles.border_sen_radius}
                        //       >
                        //         <Image
                        //           src={categoryState.data?.mob_inner_banner_1}
                        //           layout="responsive"
                        //           alt="Mobile Inner banner 1"
                        //           priority
                        //           width={696}
                        //           height={589}
                        //            objectFit="cover"
                        //            sizes="100vw"
                        //           loader={S3ImageLoader}
                        //         />
                        //       </a>
                        //     </div>
                        //   )}
                        //   {index == 18 && categoryState.data?.inner_banner_2 && (
                        //     <div className="col-md-12 col-lg-12 col-12 d-none d-md-block">
                        //        <a className={styles.border_sen_radius}>
                        //                             <Image
                        //                               src={categoryState.data?.inner_banner_2}
                        //                               layout="responsive"
                        //                               width={1920}
                        //                               height={400}
                        //                               objectFit="cover"
                        //                               alt="Inner banner 2"
                        //                               priority
                        //                               sizes="100vw"
                        //                               loader={S3ImageLoader}
                        //                             />
                        //                           </a>
                        //     </div>
                        //   )}
                        //   {/* mobile banner 2 */}
                        //   {index == 18 && categoryState.data?.mob_inner_banner_2 && (
                        //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                        //       <a className={styles.border_sen_radius}
                        //       >
                        //         <Image
                        //           src={categoryState.data?.mob_inner_banner_2}
                        //           layout="responsive"
                        //           alt="Mobile Inner banner 2"
                        //           priority
                        //           width={696}
                        //           height={589}
                        //            objectFit="cover"
                        //            sizes="100vw"
                        //           loader={S3ImageLoader}
                        //         />
                        //       </a>
                        //     </div>
                        //   )}
                        //   {index == 30 && categoryState.data?.inner_banner_3 && (
                        //     <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
                        //       <div
                        //         className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
                        //       >
                        //         <Image
                        //           src={categoryState.data?.inner_banner_3}
                        //           layout="fill"
                        //           alt="Inner banner 3"
                        //           priority
                        //           width={696}
                        //           height={589}
                        //           sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
                        //           loader={S3ImageLoader}
                        //         />
                        //       </div>
                        //     </div>
                        //   )}
                        //   {/* mobile banner 3 */}
                        //   {index == 30 && categoryState.data?.mob_inner_banner_3 && (
                        //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                        //       <a className={styles.border_sen_radius}
                        //       >
                        //         <Image
                        //           src={categoryState.data?.mob_inner_banner_3}
                        //           layout="responsive"
                        //           alt="Mobile Inner banner 3"
                        //           priority
                        //           width={696}
                        //           height={589}
                        //            objectFit="cover"
                        //            sizes="100vw"
                        //           loader={S3ImageLoader}
                        //         />
                        //       </a>
                        //     </div>
                        //   )}
                        //   {index == 40 && categoryState.data?.inner_banner_4 && (
                        //     <div className="col-md-12 col-lg-12 col-12 ">
                        //                         <a className={`${styles.border_sen_radius} ${"d-none d-md-block"}`}
                        //                         >
                        //                           <Image
                        //                             src={categoryState.data?.inner_banner_4}
                        //                            layout="responsive"
                        //                             width={1920}
                        //                             height={400}
                        //                             objectFit="cover"
                        //                             alt="Inner banner 4"
                        //                             priority
                        //                             sizes="100vw"
                        //                             loader={S3ImageLoader}
                        //                           />
                        //                         </a>
                        //                       </div>
                        //   )}
                        //   {/* mobile banner 4 */}
                        //   {index == 38 && categoryState.data?.mob_inner_banner_4 && (
                        //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                        //       <a className={styles.border_sen_radius}
                        //       >
                        //         <Image
                        //           src={categoryState.data?.mob_inner_banner_4}
                        //           layout="responsive"
                        //           alt="Mobile Inner banner 4"
                        //           priority
                        //           width={696}
                        //           height={589}
                        //           objectFit="cover"
                        //            sizes="100vw"
                        //           loader={S3ImageLoader}
                        //         />
                        //       </a>
                        //     </div>
                        //   )}
                        //   <div className="col-md-6 col-lg-3 col-6">
                        //     <ProductCardUnbxd product={product} />
                        //   </div>
                        // </Fragment>
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                index == 10 && ((ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.inner_banner_1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-none d-md-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref1 = categoryState.data) === null || ref1 === void 0 ? void 0 : ref1.inner_banner_1,
                                            layout: "fill",
                                            alt: "Inner banner 1",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 10 && ((ref2 = categoryState.data) === null || ref2 === void 0 ? void 0 : ref2.mob_inner_banner_1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-block d-md-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).border_sen_radius,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref3 = categoryState.data) === null || ref3 === void 0 ? void 0 : ref3.mob_inner_banner_1,
                                            layout: "responsive",
                                            alt: "Mobile Inner banner 1",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            objectFit: "cover",
                                            sizes: "100vw",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 14 && ((ref4 = categoryState.data) === null || ref4 === void 0 ? void 0 : ref4.inner_banner_2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-none d-md-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref5 = categoryState.data) === null || ref5 === void 0 ? void 0 : ref5.inner_banner_2,
                                            layout: "fill",
                                            alt: "Inner banner 2",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 14 && ((ref6 = categoryState.data) === null || ref6 === void 0 ? void 0 : ref6.mob_inner_banner_2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-block d-md-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).border_sen_radius,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref7 = categoryState.data) === null || ref7 === void 0 ? void 0 : ref7.mob_inner_banner_2,
                                            layout: "responsive",
                                            alt: "Mobile Inner banner 2",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            objectFit: "cover",
                                            sizes: "100vw",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 20 && ((ref8 = categoryState.data) === null || ref8 === void 0 ? void 0 : ref8.landscape_inner_banner) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-12 col-12 d-none d-md-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).border_sen_radius,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref9 = categoryState.data) === null || ref9 === void 0 ? void 0 : ref9.landscape_inner_banner,
                                            layout: "responsive",
                                            alt: "Landscape Inner banner",
                                            priority: true,
                                            width: 1920,
                                            height: 400,
                                            objectFit: "cover",
                                            sizes: "100vw",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 30 && ((ref10 = categoryState.data) === null || ref10 === void 0 ? void 0 : ref10.inner_banner_3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-none d-md-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref11 = categoryState.data) === null || ref11 === void 0 ? void 0 : ref11.inner_banner_3,
                                            layout: "fill",
                                            alt: "Inner banner 3",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 30 && ((ref12 = categoryState.data) === null || ref12 === void 0 ? void 0 : ref12.mob_inner_banner_3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-block d-md-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).border_sen_radius,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref13 = categoryState.data) === null || ref13 === void 0 ? void 0 : ref13.mob_inner_banner_3,
                                            layout: "responsive",
                                            alt: "Mobile Inner banner 3",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            objectFit: "cover",
                                            sizes: "100vw",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 38 && ((ref14 = categoryState.data) === null || ref14 === void 0 ? void 0 : ref14.inner_banner_4) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-none d-md-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((product_list_module_default()).position_relative, " ").concat((product_list_module_default()).w_100, " ").concat((product_list_module_default()).custom_height_list, " ").concat((product_list_module_default()).h_100),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref15 = categoryState.data) === null || ref15 === void 0 ? void 0 : ref15.inner_banner_4,
                                            layout: "fill",
                                            alt: "Inner banner 4",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                index == 38 && ((ref16 = categoryState.data) === null || ref16 === void 0 ? void 0 : ref16.mob_inner_banner_4) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 col-lg-6 col-12 d-block d-md-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (product_list_module_default()).border_sen_radius,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref17 = categoryState.data) === null || ref17 === void 0 ? void 0 : ref17.mob_inner_banner_4,
                                            layout: "responsive",
                                            alt: "Mobile Inner banner 4",
                                            priority: true,
                                            width: 696,
                                            height: 589,
                                            objectFit: "cover",
                                            sizes: "100vw",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 col-lg-3 col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card, {
                                        product: product
                                    })
                                })
                            ]
                        }, product.sku);
                    }),
                    !((ref17 = categoryState.products) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.response) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.products) === null || ref19 === void 0 ? void 0 : ref19.length) && !categoryState.productsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-center",
                        children: "No records found"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (product_list_module_default()).show_contant,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination_counter/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row mb-4 mt-4 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).breadcrumb_main,
                                    children: !isSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-4 d-flex flex-column align-items-center justify-content-center",
                                children: [
                                    isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex align-items-center justify-content-center py-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            role: "status",
                                            style: {
                                                color: "rgb(143, 0, 6)"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "visually-hidden",
                                                children: "Loading..."
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: bottomRef,
                                        style: {
                                            height: "10px",
                                            width: "100%"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 text-md-end text-center mt-3 mt-md-0"
                            })
                        ]
                    }),
                    !!((ref20 = categoryState.data) === null || ref20 === void 0 ? void 0 : ref20.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (product_list_module_default()).product_list_seo_text_size,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (product_list_module_default()).product_list_contant,
                                    children: [
                                        !!categoryState.data.content.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (product_list_module_default()).product_heading_text,
                                            children: categoryState.data.content.title
                                        }),
                                        !!categoryState.data.content.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (product_list_module_default()).product_bottomg_text,
                                            dangerouslySetInnerHTML: {
                                                __html: categoryState.data.content.description.replace(/nofollow/g, "").replace(/noopener/g, "").replace(/noreferrer/g, "")
                                            }
                                        })
                                    ]
                                }),
                                !!((ref21 = categoryState.data.content.items) === null || ref21 === void 0 ? void 0 : ref21.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (product_list_module_default()).accordion_container,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                        defaultActiveKey: "0",
                                        children: categoryState.data.content.items.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                                eventKey: "".concat(index),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                                        as: "div",
                                                        children: item.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.description.replace(/nofollow/g, "").replace(/noopener/g, "").replace(/noreferrer/g, "")
                                                        }
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var products_list = (CategoryProductsListUnbxd);


/***/ }),

/***/ 35098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84849);
/* harmony import */ var _styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79356);
/* harmony import */ var _styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var ProductCardSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().product),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pad_10),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            width: 100
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            width: 200
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            marginTop: 30,
                            height: 230
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            marginTop: 20,
                            width: 150
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().product_details),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_2___default().pad_10),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        style: {
                            width: 150
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardSkeleton);


/***/ }),

/***/ 48825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ combineCategoryFilters; }
/* harmony export */ });
var combineCategoryFilters = function(query) {
    var data = {};
    if (query.priceMin) {
        data["priceMin"] = query.priceMin;
    }
    if (query.priceMax) {
        data["priceMax"] = query.priceMax;
    }
    if (query.metal) {
        data["metal"] = query.metal;
    }
    if (query.size) {
        data["size"] = query.size;
    }
    if (query.occasion) {
        data["occasion"] = query.occasion;
    }
    if (query.fastDelivery) {
        data["fastDelivery"] = query.fastDelivery;
    }
    if (query.try_it_online) {
        data["try_it_online"] = query.try_it_online;
    }
    if (query.sort) {
        data["sort"] = query.sort;
    }
    return data;
};


/***/ }),

/***/ 82560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ toTitleCase; }
/* harmony export */ });
var toTitleCase = function(str) {
    return str.replace(/_/g, " ").replace(/(\w*\W*|\w*)\s*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};


/***/ }),

/***/ 84849:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* unused harmony export SkeletonTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (React.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ })

}]);